import type { ReactNode } from "react";

export type BadgeTone = "neutral" | "success" | "warning" | "danger" | "info";

export function Badge({ tone = "neutral", children }: { tone?: BadgeTone; children: ReactNode }) {
  return <span className={`ods-badge ods-badge--${tone}`}>{children}</span>;
}

const RISK_TONE: Record<string, BadgeTone> = { high: "danger", medium: "warning", low: "success" };

export function RiskBadge({ level }: { level: string }) {
  return <Badge tone={RISK_TONE[level] ?? "neutral"}>{level.toUpperCase()} RISK</Badge>;
}

const STATUS_TONE: Record<string, BadgeTone> = {
  active: "success",
  paid: "success",
  trialing: "info",
  open: "info",
  in_review: "warning",
  processing: "warning",
  past_due: "danger",
  overdue: "danger",
  canceled: "danger",
  expired: "danger",
  draft: "neutral",
};

export function StatusBadge({ status }: { status: string }) {
  const label = status.replace(/_/g, " ");
  return <Badge tone={STATUS_TONE[status] ?? "neutral"}>{label}</Badge>;
}
